import { useTranslation } from "react-i18next";

export const useMoodsTranslator = () => {
  const { t } = useTranslation();
  return {
    Worry: t("homepage.worry"),
    Apathy: t("homepage.apathy"),
    Relaxation: t("homepage.relaxation"),
    Flow: t("homepage.flow"),
    Arousal: t("homepage.arousal"),
    Anxiety: t("homepage.anxiety"),
    Boredom: t("homepage.boredom"),
    Control: t("homepage.confident"),
  };
};
